module.exports = __webpack_public_path__ + "static/media/bank-revolut.06fcae49.svg";